export const watchStorage = ({ methodsAvailable, storage, callbackAfter }) => {
    methodsAvailable.forEach((method) => {
        const original = storage[method].bind(storage);
        const newMethod = (...args) => {
            const result = original.apply(null, args);
            callbackAfter?.(method, ...args);
            return result;
        };
        storage[method] = newMethod.bind(storage);
    });
};
//# sourceMappingURL=helpers.js.map